import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation, useNavigate } from 'react-router-dom';
import { routes } from 'routes/routes';
import { Box, List, ListItemButton, ListItemText } from '@mui/material';
import styles from './SideBar.module.scss';
import { useTranslation } from 'react-i18next';
import { NAV_ITEMS } from './sideBarItems';
export const SideBar = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation('sideBar');
    const items = NAV_ITEMS.map((item) => (Object.assign(Object.assign({}, item), { label: t(item.translationKey) })));
    return (_jsx(Box, { className: styles.sidebar, component: "nav", children: _jsx(List, { disablePadding: true, className: styles.navList, children: items.map((item) => {
                const isRoot = location.pathname === routes.OVERVIEW;
                const isActive = (item.route === routes.PROFILE && isRoot) ||
                    location.pathname === item.route ||
                    (item.route !== routes.OVERVIEW && location.pathname.startsWith(item.route));
                return (_jsxs(ListItemButton, { className: `${styles.navItem} ${isActive ? styles.navItemActive : ''}`, onClick: () => navigate(item.route), children: [_jsx("span", { className: styles.navIndicator }), _jsx(ListItemText, { primary: item.label, primaryTypographyProps: { className: styles.navLabel } })] }, item.id));
            }) }) }));
};
